module.exports = __webpack_public_path__ + "static/media/4.026cb7af.jpeg";